// extracted by css-extract-rspack-plugin
export default {"cls1":"Playlist-cls1_zvB","cls2":"Playlist-cls2_Gvl Playlist-cls1_zvB"};